import { instance } from "./instance";
import { StationResponse, StationsResponse } from "../types/station";

const axios = instance("STATION");

export const getStation = async (stationId: string): Promise<StationResponse> => {
  const response = await axios.get<StationResponse>(`station/${stationId}`);
  return response.data;
};

export const getNearestStation = async (latitude: number, longitude: number): Promise<StationResponse> => {
  const response = await axios.get<StationResponse>(`station/nearest?latitude=${latitude}&longitude=${longitude}`);
  return response.data;
};

export const getStations = async (): Promise<StationsResponse> => {
  const response = await axios.get<StationsResponse>(`station`);
  return response.data;
};